import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { PhoneInput } from '@atlas/components';
import { SessionStorageManager } from '@atlas/core';

import Field from 'common/Form/Field';
import useTranslate from 'common/I18n/Interpreter';
import { useIsRtl } from 'hooks/useIsRtl';

const DEFAULT_COUNTRY = 'br';

const PhoneField = props => {
  const { field, onBlur, onChange, onFocus } = props;
  const isRtl = useIsRtl();

  const country = SessionStorageManager.getItem('client-country') || DEFAULT_COUNTRY;

  const { autocomplete, disabled, errors, isModifiable = true, name, placeholder, value } = field;

  const t = useTranslate();

  const changeHandler = useCallback(
    (value = '') => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <Field className="block" isSignupForm options={field}>
      <PhoneInput
        autocomplete={autocomplete}
        defaultCountry={country.toLowerCase()}
        disabled={disabled || !isModifiable}
        emptySearchText={t('country_not_found')}
        error={!!errors?.length && field.touched}
        isRtl={isRtl}
        name={name}
        onBlur={onBlur}
        onChange={changeHandler}
        onFocus={onFocus}
        placeholder={placeholder}
        renderCountryName={country => t(`country_${country.iso2}`)}
        searchInputPlaceholder={t('country_search')}
        value={value || ''}
      />
    </Field>
  );
};

PhoneField.propTypes = {
  field: PropTypes.shape({
    active: PropTypes.bool,
    autocomplete: PropTypes.string,
    autofocus: PropTypes.bool,
    disabled: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.object),
    isModifiable: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    rules: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    touched: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default PhoneField;
